// client/src/lib/i18n.ts
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

// Import translations - use relative paths
import enCommon from "@/locales/en/common.json";
import enAttendance from "@/locales/en/attendance.json";
import enIntake from "@/locales/en/intake.json";
import enFoods from "@/locales/en/foods.json";
import enClients from "@/locales/en/clients.json";
import enMeasurements from "@/locales/en/measurements.json";
import enStrengthProgress from "@/locales/en/strengthProgress.json";
import enHome from "@/locales/en/home.json";
import enMealLibrary from "@/locales/en/mealLibrary.json";
import enAdmin from "@/locales/en/admin.json";

import skCommon from "@/locales/sk/common.json";
import skAttendance from "@/locales/sk/attendance.json";
import skIntake from "@/locales/sk/intake.json";
import skFoods from "@/locales/sk/foods.json";
import skClients from "@/locales/sk/clients.json";
import skMeasurements from "@/locales/sk/measurements.json";
import skStrengthProgress from "@/locales/sk/strengthProgress.json";
import skHome from "@/locales/sk/home.json";
import skMealLibrary from "@/locales/sk/mealLibrary.json";
import skAdmin from "@/locales/sk/admin.json";

const resources = {
  en: {
    common: enCommon,
    attendance: enAttendance,
    intake: enIntake,
    foods: enFoods,
    clients: enClients,
    measurements: enMeasurements,
    strengthProgress: enStrengthProgress,
    home: enHome,
    mealLibrary: enMealLibrary,
    admin: enAdmin,
  },
  sk: {
    common: skCommon,
    attendance: skAttendance,
    intake: skIntake,
    foods: skFoods,
    clients: skClients,
    measurements: skMeasurements,
    strengthProgress: skStrengthProgress,
    home: skHome,
    mealLibrary: skMealLibrary,
    admin: skAdmin,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources, // Use the single resources object
    fallbackLng: "sk", // Default to Slovak
    defaultNS: "common",
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
    },
  });

// Ensure consistent language updating across all components
i18n.on("languageChanged", () => {
  // This ensures components update when language changes
  if (typeof window !== "undefined") {
    // Trigger a refresh on components that depend on translations
    // In a React app, this should cause proper re-renders when using useTranslation
  }
});

export default i18n;
